export const STATS_ROLES = ['ua_team'];
